function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Formatter } from '@deephaven/jsapi-utils';
import IrisGridProxyModel from "./IrisGridProxyModel.js";
import IrisGridUtils from "./IrisGridUtils.js";
class IrisGridTestUtils {
  static valueForCell(rowIndex, columnIndex, formatValue) {
    var value = "".concat(rowIndex, ",").concat(columnIndex);
    if (formatValue !== undefined && formatValue) {
      value = "(".concat(value, ")");
    }
    return value;
  }
  constructor(dh) {
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "irisGridUtils", void 0);
    this.dh = dh;
    this.irisGridUtils = new IrisGridUtils(dh);
  }
  makeColumn(name) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IrisGridTestUtils.DEFAULT_TYPE;
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new this.dh.Column({
      index,
      name,
      type
    });
  }
  makeRollupTableConfig() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new this.dh.RollupTableConfig();
  }
  makeColumns() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var columns = [];
    for (var i = 0; i < count; i += 1) {
      columns.push(this.makeColumn("".concat(prefix).concat(i), IrisGridTestUtils.DEFAULT_TYPE, i));
    }
    return columns;
  }
  static makeUserColumnWidths() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var userColumnWidths = new Map();
    for (var i = 0; i < count; i += 1) {
      userColumnWidths.set(i.toString(), 100);
    }
    return userColumnWidths;
  }
  makeRow(i) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var row = new this.dh.Row({
      index: i,
      name: "".concat(i)
    });
    row.get = jest.fn(column => IrisGridTestUtils.valueForCell(i, column.index));
    return row;
  }
  makeFilter() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new this.dh.FilterCondition();
  }
  makeSort() {
    var column = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.makeColumn();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new this.dh.Sort({
      column
    });
  }
  hydrateSort(sortDescriptor, columns) {
    return this.irisGridUtils.hydrateDhSort(columns, sortDescriptor);
  }
  makeTable() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? this.makeColumns() : _ref$columns,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1000000000 : _ref$size,
      _ref$sort = _ref.sort,
      sort = _ref$sort === void 0 ? [] : _ref$sort,
      _ref$layoutHints = _ref.layoutHints,
      layoutHints = _ref$layoutHints === void 0 ? {} : _ref$layoutHints;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var table = new this.dh.Table({
      columns,
      size,
      sort
    });
    table.copy = jest.fn(() => Promise.resolve(table));
    table.freeze = jest.fn(() => Promise.resolve(table));
    table.layoutHints = layoutHints;
    return table;
  }
  makeTreeTable() {
    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.makeColumns();
    var aggregatedColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var groupedColumns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000000000;
    var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var layoutHints = arguments.length > 5 ? arguments[5] : undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var table = new this.dh.TreeTable({
      columns,
      aggregatedColumns,
      groupedColumns,
      size,
      sort,
      layoutHints
    });
    table.copy = jest.fn(() => Promise.resolve(table));
    return table;
  }
  static makeInputTable() {
    var keyColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var valueColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _reduce = [...keyColumns, ...valueColumns].reduce((acc, col) => {
        if (keyColumns.includes(col)) acc.keys.push(col.name);else acc.values.push(col.name);
        return acc;
      }, {
        keys: [],
        values: []
      }),
      keys = _reduce.keys,
      values = _reduce.values;
    return {
      keys,
      values
    };
  }
  makeSubscription() {
    var table = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.makeTable();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new this.dh.TableViewportSubscription({
      table
    });
  }
  makeModel() {
    var table = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.makeTable();
    var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var inputTable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var dh = this.dh;
    return new IrisGridProxyModel(dh, table, formatter !== null && formatter !== void 0 ? formatter : new Formatter(dh), inputTable);
  }
}
_defineProperty(IrisGridTestUtils, "DEFAULT_TYPE", 'java.lang.String');
export default IrisGridTestUtils;
//# sourceMappingURL=IrisGridTestUtils.js.map